// extracted by mini-css-extract-plugin
export default {"card":"card1_card__I3UeT","box":"card1_box__aoqSn","boxContent":"card1_boxContent__wcXPE","line":"card1_line__eHugS"};